export class GenericExternalCommandType{
	code: string;
	icon: string;
	type: string;
	text: string;
	disabled: boolean;

    constructor(){
		this.reset();
    }

    setAllValue(code: string, icon: string, type: string, text: string, disabled: boolean){
		this.reset();
		this.code = code;
		this.icon = icon;
		this.type = type;
		this.text = text;
		this.disabled = disabled;
	}

    reset(){
		this.code = "";
		this.icon = "";
		this.type = "";
		this.text = "";
		this.disabled = false;
	}
};
